import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateDashboardByIdThunk } from "../common/updateDashboardByIdThunk";
import { RootState } from "@/store/store";
import { Dates } from "@/services/cloudchipr.api";
import { dashboardByIdDataSelector } from "@/store/dashboards/selectors/dashboard/dashboardByIdDataSelector";
import { getWidgetDataByTypeAndIdThunk } from "@/store/dashboards/thunks/widgets/common/getWidgetDataByTypeAndIdThunk";
import { generateWidgetInnerContentId } from "@/components/pages/dashboard/utils/helpers/widget/generateWidgetInnerContentId";
import { updateWidgetThunk } from "@/store/dashboards/thunks/widgets/common/updateWidgetThunk";
import { widgetByIdSelector } from "@/store/dashboards/selectors/widgets/common/widgetByIdSelector";
import { UpdateDashboardWidgetRequestType } from "@/store/dashboards/utils/types/types";
import { getDashboardByIdThunk } from "@/store/dashboards/thunks/dashboard/getDashboardByIdThunk";

export const updateDashboardDateThunk = createAsyncThunk(
  "dashboards/updateDashboardDate",
  async (
    { dates, dashboardId }: { dates: Dates; dashboardId: string },
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;

    const dashboard = dashboardByIdDataSelector(state, dashboardId);

    await dispatch(updateDashboardByIdThunk({ dashboardId, body: { dates } }));
    await dispatch(getDashboardByIdThunk(dashboardId));

    const widgetUpdatePromises: Promise<any>[] = [];

    dashboard?.widgets?.forEach((widget) => {
      if (!("inherit_dates" in widget && widget.inherit_dates)) {
        return;
      }

      const widgetData = widgetByIdSelector(
        state,
        widget.id,
      ) as UpdateDashboardWidgetRequestType;

      widgetUpdatePromises.push(
        dispatch(
          updateWidgetThunk({
            preventLayoutUpdate: true,
            widgetId: widget.id,
            widget: { ...widgetData, dates },
          }),
        ).unwrap(),
      );
    });

    const responses = await Promise.all(widgetUpdatePromises);
    await dispatch(getDashboardByIdThunk(dashboardId));

    responses?.forEach((widget) => {
      const widgetIsVisible = document.getElementById(
        generateWidgetInnerContentId(widget.id),
      );

      if (!widgetIsVisible) {
        return;
      }

      dispatch(
        getWidgetDataByTypeAndIdThunk({
          widgetId: widget.id,
          type: widget.type,
        }),
      );
    });
  },
);
